import {
    QueueingTimeDisplayFormat,
    useQueueingTimer,
} from 'hooks/queueTime'
import React from 'react'
import {styled} from 'stitches/config'
import {styledQueueingTime} from './styles'

const StyledQueueingTime = styled('div', styledQueueingTime)

type QueueingTimeVariant = 'button' | 'sidebar'

type QueueingTimeViewProps = {
    delivery_time?: number
    displayFormat?: QueueingTimeDisplayFormat
    end_time?: number
    queue_time: number
    queueLength: number
    sla?: boolean
    slaReminderTime?: string
    slaWarningTime?: string
    timerKey?: string
    variant?: QueueingTimeVariant
}

const QueueingTimeView: React.FC<QueueingTimeViewProps> = ({
    queue_time,
    delivery_time,
    displayFormat = 'precise',
    end_time,
    queueLength,
    sla,
    slaReminderTime,
    slaWarningTime,
    timerKey,
    variant = 'sidebar',
}) => {
    const {
        dateTime,
        slaState,
        time,
    } = useQueueingTimer({
        deliveryTime: delivery_time,
        displayFormat,
        endTime: end_time,
        queueLength,
        queueTime: queue_time,
        sla,
        slaReminderTime,
        slaWarningTime,
        timerKey,
    })

    if (!dateTime || !time) {
        return null
    }

    return (
        <StyledQueueingTime slaState={slaState} variant={variant}>
            <time dateTime={dateTime}>{time}</time>
        </StyledQueueingTime>
    )
}

QueueingTimeView.defaultProps = {
    delivery_time: undefined,
    displayFormat: 'precise',
    end_time: undefined,
    sla: false,
    slaReminderTime: undefined,
    slaWarningTime: undefined,
    timerKey: undefined,
    variant: 'sidebar',
}

export default QueueingTimeView
